import {

    GET_MCC_SUCCESS,
    ADD_MCC_SUCCESS,
    UPDATE_MCC_SUCCESS,
    DELETE_MCC_SUCCESS,
    MCC_API_ERROR,
    GET_RANGE_ISO_SUCCESS,
    GET_MCC_MASTERCARD_SERVİCE_CATEGORY_SUCCESS,
    GET_VISA_SERVICE_CATEGORY_SUCCESS,
    GET_MCC_NATIONAL_SWITCH_CATEGORY_SUCCESS,
    GET_MCC_GEOGRAPHY_TYPE_SUCCESS
  } from "./actionTypes"
  
  const INIT_STATE = {
    recordList: [], //Model Data ve Error
    recordMccİsoRangeList: [],
    recordMccMastercardServiceList: [],
    recordMccVisaServiceList: [],
    recordMccNationalSwitchList: [],
    recordMccGeographyTypeList: [],
    error: {},
  }
  
  
  const MccDefinition = (state = INIT_STATE, action) => {
    switch (action.type) {
      case GET_MCC_GEOGRAPHY_TYPE_SUCCESS:
        return {
          ...state,
          recordMccGeographyTypeList: action.payload,
        }
      case GET_MCC_NATIONAL_SWITCH_CATEGORY_SUCCESS:
        return {
          ...state,
          recordMccNationalSwitchList: action.payload,
        }
  
      case GET_VISA_SERVICE_CATEGORY_SUCCESS:
        return {
          ...state,
          recordMccVisaServiceList: action.payload,
        }
      case GET_MCC_MASTERCARD_SERVİCE_CATEGORY_SUCCESS:
        return {
          ...state,
          recordMccMastercardServiceList: action.payload,
        }
  
      case GET_RANGE_ISO_SUCCESS:
        return {
          ...state,
          recordMccİsoRangeList: action.payload,
        }
  
      case GET_MCC_SUCCESS:
      case ADD_MCC_SUCCESS:
      case UPDATE_MCC_SUCCESS:
        return {
          ...state,
          recordList: action.payload,
        }
  
      case DELETE_MCC_SUCCESS:
        return {
          ...state,
          recordList: state.recordList.filter(
            record => record.guid.toString() !== action.payload.toString()
          ),
        }
  
      case MCC_API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
  
      default:
  
        return state
  
    }
  }
  
  export default MccDefinition